// extracted by mini-css-extract-plugin
export default {"page":"uP","headerwrap":"vP","headerblock":"wP","textwrapper":"xP","text":"yP","closerlook":"zP","arrowwrap":"AP","icon":"BP","updown":"CP","products":"EP","system":"FP","systemimage":"GP","cards":"HP","note":"IP","fadein":"JP"};
    if(module.hot) {
      // 1715188238001
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  